module.exports = __webpack_public_path__ + "img/logo.47f76915.png";